// exports.joi will be removed soon
exports.joiExtension = exports.joi = require("./joiExtension");
